import { __awaiter } from "tslib";
export const TYPE_SESSION_STORAGE = 'sessionStorage';
export const TYPE_LOCAL_STORAGE = 'localStorage';
export function storageAvailable(type) {
    try {
        const storage = window[type], x = '__storage_test__';
        storage.setItem(x, x);
        return true;
    }
    catch (e) {
        return false;
    }
}
export function setItemToStorage(key, value, type) {
    try {
        storageAvailable(type) && window[type].setItem(key, value);
    }
    catch (e) {
        // no-op
    }
}
export function setItemToStorageAsync(key, value, type) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!storageAvailable(type)) {
            throw new Error(type + ' unavailable');
        }
        //? This can throw `QuotaExceededError` if storage quota has been exceeded.
        //? Allow this function to throw to we can catch and handle the error
        window[type].setItem(key, value);
        return true;
    });
}
export function removeItemFromStorage(key, type) {
    try {
        storageAvailable(type) && window[type].removeItem(key);
    }
    catch (e) {
        // no-op
    }
}
export const getItemFromStorage = (key, type) => {
    try {
        return storageAvailable(type) ? window[type].getItem(key) : null;
    }
    catch (e) {
        return null;
    }
};
export const getItemLocalStorage = (key) => {
    return getItemFromStorage(key, TYPE_LOCAL_STORAGE);
};
export function setItemLocalStorage(key, value) {
    return setItemToStorage(key, value, TYPE_LOCAL_STORAGE);
}
export function setItemLocalStorageAsync(key, value) {
    return setItemToStorageAsync(key, value, TYPE_LOCAL_STORAGE);
}
export function removeItemLocalStorage(key) {
    return removeItemFromStorage(key, TYPE_LOCAL_STORAGE);
}
